<template>
  <div class="btn-group">
    <div class="dropdown">
      <button type="button" class="btn btn-sm btn-outline-primary dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Werkruimtes opslaan en laden">
        <svg width="1em" height="1em" viewBox="0 0 16 16" class="align-baseline bi bi-info-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M2 4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v11.5a.5.5 0 0 1-.777.416L7 13.101l-4.223 2.815A.5.5 0 0 1 2 15.5V4zm2-1a1 1 0 0 0-1 1v10.566l3.723-2.482a.5.5 0 0 1 .554 0L11 14.566V4a1 1 0 0 0-1-1H4z"/>
          <path fill-rule="evenodd" d="M4.268 1H12a1 1 0 0 1 1 1v11.768l.223.148A.5.5 0 0 0 14 13.5V2a2 2 0 0 0-2-2H6a2 2 0 0 0-1.732 1z"/>
        </svg>
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a class="dropdown-item" href="#" v-on:click="addBookmark">Opslaan...</a>
        <a class="dropdown-item" href="#" v-on:click="openAutoBackupOverview">
          <svg width="1em" height="1em" viewBox="0 0 16 16" class="align-baseline bi bi-clock-history" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7 7 0 0 0-.985-.299l.219-.976q.576.129 1.126.342zm1.37.71a7 7 0 0 0-.439-.27l.493-.87a8 8 0 0 1 .979.654l-.615.789a7 7 0 0 0-.418-.302zm1.834 1.79a7 7 0 0 0-.653-.796l.724-.69q.406.429.747.91zm.744 1.352a7 7 0 0 0-.214-.468l.893-.45a8 8 0 0 1 .45 1.088l-.95.313a7 7 0 0 0-.179-.483m.53 2.507a7 7 0 0 0-.1-1.025l.985-.17q.1.58.116 1.17zm-.131 1.538q.05-.254.081-.51l.993.123a8 8 0 0 1-.23 1.155l-.964-.267q.069-.247.12-.501m-.952 2.379q.276-.436.486-.908l.914.405q-.24.54-.555 1.038zm-.964 1.205q.183-.183.35-.378l.758.653a8 8 0 0 1-.401.432z"/>
            <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0z"/>
            <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5"/>
          </svg>
          Auto-backup...
        </a>
        <div class="dropdown-divider" v-if="bookmarkList.length > 0"></div>
        <div class="dropdown-item d-flex cursor-pointer" v-for="bookmark in bookmarkList" :key="bookmark.name" v-on:click="openBookmark(bookmark)">
          <div class="flex-grow-1 me-3">
            <p class="mb-0">{{ bookmark.name }}</p>
            <p class="mb-0 fst-italic small text-muted">{{ formatDateTime(bookmark.date) }}</p>
          </div>

          <div class="d-flex flex-column justify-content-center">
            <button class="btn btn-sm btn-control" type="button" v-on:click="deleteBookmark($event, bookmark)">
              <svg width="1em" height="1em" viewBox="0 0 16 16" class="align-baseline bi bi-trash-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7z"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
        class="modal"
        tabindex="-1"
        role="dialog"
        id="bookmarks_add_modal"
        data-bs-backdrop="false"
        data-bs-keyboard="false"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Werkruimte opslaan</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p class="small">
              Sla de huidige werkruimte op om deze later weer te kunnen gebruiken.
              <span v-if="bookmarkList.length > 0">Je kunt een nieuwe werkruimte maken, of een bestaande overschrijven.</span>
            </p>

            <h5 v-if="bookmarkList.length > 0">Als nieuwe werkruimte opslaan</h5>
            <div class="form-group">
              <label for="bookmark_name" class="form-label">Naam</label>

              <div class="input-group mb-3">
                <input type="text" class="form-control" id="bookmark_name" placeholder="Typ een naam...">
                <button class="btn btn-primary" type="button" v-on:click="setBookmark">Opslaan</button>
              </div>
            </div>

            <div v-if="bookmarkList.length > 0">
              <hr />
              <h5>Een bestaande werkruimte overschrijven</h5>
              <div class="list-group">
                <div
                    class="list-group-item list-group-item-action d-flex cursor-pointer"
                    v-for="bookmark in bookmarkList"
                    v-on:click="updateBookmark(bookmark)"
                >
                  <div class="flex-grow-1">{{ bookmark.name }}</div>
                  <div class="fst-italic small text-muted">{{ formatDateTime(bookmark.date) }}</div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div
        class="modal"
        tabindex="-1"
        role="dialog"
        id="auto_backup_modal"
        data-bs-backdrop="false"
        data-bs-keyboard="false"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Automatisch opgeslagen backups</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p class="small">
              Hieronder vind je automatisch opgeslagen backups van je werkruimtes. Klik op een backup om deze te openen.
              Backups worden elke minuut opgeslagen in je browser-opslag.
              Er worden tot maximaal 10 backups maximaal 7 dagen automatisch opgeslagen.
            </p>

            <h5>Automatisch opgeslagen backup inladen</h5>
            <div v-if="autoBackupsData.autobackups.length > 0">
              <div class="list-group">
                <div
                    class="list-group-item list-group-item-action cursor-pointer"
                    v-for="autoBackup in autoBackupsData.autobackups"
                    v-on:click="loadAutoBackup(autoBackup)"
                >
                  <div class="d-flex">
                    <div class="flex-grow-1" v-if="autoBackup.name">{{ autoBackup.name }}</div>
                    <div class="flex-grow-1 fst-italic text-muted" v-else>Naamloos</div>
                    <div class="fst-italic small text-muted">{{ formatDateTime(autoBackup.date) }}</div>
                    <div class="ms-3">
                      <button class="btn btn-sm btn-control" type="button" v-on:click="deleteAutoBackup($event, autoBackup)">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="align-baseline bi bi-trash-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7z"/>
                        </svg>
                      </button>
                    </div>
                  </div>
                  <div class="fst-italic size60 text-muted">
                    {{ autoBackup.num_cutouts }} kaarten, {{ autoBackup.num_routes }} routes, {{ autoBackup.num_locations }} punten, {{ autoBackup.num_shapes }} vormen
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <p class="small fst-italic text-muted">Er zijn op dit moment geen automatisch opgeslagen backups.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import $ from "jquery";
import Bookmarks, {Bookmark} from "../Main/Bookmarks";
import AutoBackups, {AutoBackupReactive} from "../Main/AutoBackups.js";
import {formatDateTime} from "../Util/functions";
import {bsModal} from "../Util/vueFunctions";

export default {
  props: {
    bookmarks: Bookmarks,
    autobackups: AutoBackups,
  },
  data () {
    this.bookmarks.getUserInterface().on('storage-reset', () => {
      this.bookmarkListRecomputeCounter++;
    });

    return {
      bookmarkListRecomputeCounter: 0,
      autoBackupsData: this.autobackups.getReactive(),
    };
  },
  watch: {

  },
  computed: {
    bookmarkList: function() {
      this.bookmarkListRecomputeCounter;
      return this.bookmarks.getBookmarks();
    }
  },
  methods: {
    formatDateTime,
    addBookmark() {
      bsModal('#bookmarks_add_modal').show();
      $('#bookmark_name').val('').focus();
    },
    setBookmark() {
      const name = $('#bookmark_name').val().trim();
      if(name.length > 0 && (!this.bookmarks.hasBookmark(name) || confirm('Er bestaat al een werkruimte met de naam "'+name+'". Wil je deze overschrijven?'))) {
        this.bookmarks.setBookmark(name);
        this.autobackups.setCurrentSessionName(name);
        this.bookmarks.getUserInterface().actionHistory.afterSave();
        this.bookmarkListRecomputeCounter++;
        bsModal('#bookmarks_add_modal').hide();
      }
    },
    updateBookmark(bookmark: Bookmark) {
      if(confirm('Weet je zeker dat je "'+bookmark.name+'" wilt overschrijven?')) {
        this.bookmarks.setBookmark(bookmark.name);
        this.autobackups.setCurrentSessionName(bookmark.name);
        this.bookmarks.getUserInterface().actionHistory.afterSave();
        this.bookmarkListRecomputeCounter++;
        bsModal('#bookmarks_add_modal').hide();
      }
    },
    deleteBookmark(event, bookmark: Bookmark) {
      event.stopPropagation();
      if(confirm('Weet je zeker dat je "'+bookmark.name+'" wilt verwijderen? Deze actie kan niet worden teruggedraaid.')) {
        this.bookmarks.deleteBookmark(bookmark.name);
        this.bookmarkListRecomputeCounter++;
      }
    },
    openBookmark(bookmark: Bookmark) {
      if (this.bookmarks.getUserInterface().actionHistory.hasUnsaved()) {
        if (!confirm('Je hebt niet-opgeslagen wijzigingen die verloren kunnen gaan. Wil je doorgaan?')) {
          return;
        }
      }

      this.bookmarks.applyBookmark(bookmark.name);
      this.autobackups.setNewCurrentSession(bookmark.name);
    },
    openAutoBackupOverview() {
      bsModal('#auto_backup_modal').show();
    },
    loadAutoBackup(autoBackup: AutoBackupReactive) {
      if (this.autobackups.getUserInterface().actionHistory.hasUnsaved()) {
        if (!confirm('Je hebt niet-opgeslagen wijzigingen die verloren kunnen gaan. Wil je doorgaan?')) {
          return;
        }
      }

      this.autobackups.loadAutoBackup(autoBackup.session_id);
      bsModal('#auto_backup_modal').hide();
    },
    deleteAutoBackup(event, autoBackup: AutoBackupReactive) {
      event.stopPropagation();
      if(confirm('Weet je zeker dat je deze backup wilt verwijderen? Deze actie kan niet worden teruggedraaid.')) {
        this.autobackups.deleteAutoBackup(autoBackup.session_id);
      }
    },
  }
};
</script>

<style scoped>
.dropdown-menu {
  max-height: calc(100vh - 100px);
  overflow-y: auto;
}
</style>
